<template>
  <div class="pm-dialog-flag">

    <div class="flex justify-center" style="margin-bottom:1rem;">
      <vs-input
        class="w-1/6 mt-4"
        label=""
        v-model="flagValue"
        v-validate="'required'"
        name="flagValue"
        data-vv-as="flagValue"
        color="#2d9cdb"
        ref="input"
      />
    </div>

    <div class="flex justify-center">
      <div class="vs-row flex justify-start" style="width:80%;">
        <div class="vs-col candidate-list" v-for="(master,index) in masterList" :key="index" style="margin:0.2rem;" @mousedown="onKeyDown(master.value)">
          <vs-chip class="pm-input-key">
            {{ master.value }}
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <div class="flex justify-end" style="width:80%;" @mousedown="onClear">
        <vs-chip
          class="pm-input-key clear-button"
          style="border-radius:5px;font-size:120%;min-width:2rem;"
        >クリア</vs-chip>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      flagValue: "",
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['flag'];
    },
    enableSave() {
      return true; // this.flagValue;
    },
  },
  methods: {
    initData() {
      this.flagValue = this.valueMap ? this.valueMap.value : "";
      this.$refs.input.focusInput()
    },
    onKeyDown(key){
      const el = this.$refs.input.$refs.vsinput;
      const index = el.selectionStart;
      this.flagValue = this.flagValue ? (this.flagValue.substring(0, index) + key + this.flagValue.substring(index)) : key;
      el.focus();
      el.setSelectionRange(index + key.length , index + key.length);
      this.$nextTick(() => {
        el.setSelectionRange(index + key.length , index + key.length);
        Vue.$log.debug("flagValue cursor", index, el.selectionStart );
      });
    },
    onClear() {
      this.flagValue = "";
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = this.flagValue ? this.flagValue : null;
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-flag {
  .vs-input--input {
    height: 3rem;
    text-align: center;
    background-color: $pm-white;
  }
  .input-any {
    background-color: $pm-white;
    border: 1px solid $pm-blue;
  }
  .input-null {
    background-color: $pm-light-gray;
    border: none;
  }
  .candidate-list {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
  .pm-input-key {
    background-color: $pm-paper-white;
    border: 1px solid $pm-gray;
    color: $pm-black;
    cursor: pointer;
    &:hover {
      background-color: $pm-blue;
      border: 1px solid $pm-blue;
      color: $pm-white !important;
    }
  }
  .clear-button {
    margin: 0.5rem 0 1rem 0;
    border-radius: 5px;
    font-size: 120%;
    min-width:2rem;
    height: 3rem;
    width: 8rem;
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

